import React, { } from "react";
import "./breadcrumb.scss";
import { breadcrumbLinkPath, breadcrumbText, getBreadcrumbMapping } from "../utils";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const Breadcrumb = ({ category, sellerDetails, selectedVariant = {} }) => {
  const location = useLocation();
  const history = useSelector((s) => s.user.routeHistory);
  const providerName = sellerDetails && sellerDetails?.store?.name ? sellerDetails.store.name : sellerDetails?.name
  const breadcrumbMapping = getBreadcrumbMapping(selectedVariant, providerName, category);

  return (
    <>
      <div className="breadcrumb-nav-kl">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" >
                <ol className="breadcrumb custom-breadcrumb-kl">
                  {history?.slice(0, -1)?.map((path) => {
                    const pathArray = path.split("/").filter(Boolean);
                    const route = breadcrumbLinkPath(path, sellerDetails, category)
                    if (selectedVariant && Object.keys(selectedVariant)?.length == 0 && path == "/product-details") {
                      return
                    }
                    if (!providerName && path == "/seller") {
                      return
                    }
                    if (!category && path == "/category") {
                      return
                    }
                    if (path == "/top-grocery-stores") {
                      return
                    }
                    return (
                      <li className="breadcrumb-item custom-breadcrumb-items-kl">
                        <Link
                          to={route}
                        >
                          {breadcrumbText(path, pathArray, selectedVariant, providerName, category)}
                        </Link>
                      </li>
                    )
                  })}
                  {history?.slice(0, -1)?.length > 0 && <li className="breadcrumb-item custom-breadcrumb-items-kl active" aria-current="page">{breadcrumbMapping[location.pathname?.split("/").filter(Boolean)]}</li>}
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Breadcrumb;
